import {
  Button,
  Checkbox,
  Col,
  Divider,
  Modal,
  Pagination,
  Row,
  Table,
  TabsProps,
  message,
} from "antd";
import { HeaderTable } from "../../Components/HeaderTable";
import styles from "./RouteManager.module.scss";
import {
  buildColumnsWithHeaderFilters,
  Form,
  ModalImport,
  Tabs,
  PermissionDirect,
  TableActionButtons,
} from "../../Components";
import { decorateEditableColumns } from "../../shared/helpers/editableColumns";
import { useRequestLock } from "../../shared/hooks/useRequestLock";
import { updateColumnDisplayState } from "../../shared/helpers/tableColumns";
import { resetPaginationToFirstPage } from "../../shared/helpers/pagination";
import { PlusIcon, Setting } from "../../assets/icon";
import { useEffect, useState } from "react";
import { Form as FormAntd } from "antd";
import { RouteManagerApi, getPermissionRegions } from "../../services";
import dayjs from "dayjs";
import _ from "lodash";
import { CommonApi } from "../../services";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import { checkPermissions } from "../../utils/checkPermissions";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditFilled,
  EyeOutlined,
} from "@ant-design/icons";
import {
  applyRouteDeleteResult,
  applyRouteDetailUpdateToRows,
  applyRouteDetailToSalaryRow,
  buildRouteImportConfirmPayload,
  buildRouteBasePayload,
  buildRouteSalaryPayload,
  buildRouteVersionPayload,
  canCreateRouteRow,
  canDeleteRouteRow,
  getRouteImportValidFrom,
  getRoutePaginationAfterDelete,
  getRouteVersionActionDisabledState,
  getRouteTabChangeState,
  getRouteVersionSelectionState,
  hasNullRequiredField,
  mergeRouteColumnsWithCurrentState,
  normalizeRouteRoadType,
  removeEditedRouteRow,
  replaceRouteRowAfterSave,
  resolveRouteImportSuccessActiveRowKey,
  resolveRouteDetailRecord,
  resolveRouteSaveOutcome,
  resolveRouteVersionRowKey,
  shouldLoadRouteSalaryRows,
  toRouteDetailFormValues,
  updateEditedRows,
} from "./helpers";
import { getPermissionDirections } from "../../services/domains/permission";

const {
  getAllRouterBase,
  postPreCheckImportRouterBase,
  postConfirmImportRouterBase,
  getAllRouterSalary,
  putUpdateRouterBase,
  postAddRouterBase,
  getAllRouterSalaryVersion,
  shortDeleteRouterBase,
  putUpdateRouterSalary,
  getExportVersion,
  postCreateSalary,
  getOneRouter,
  getSearchRouterBaseVersion,
  putUpdateRouterBaseVersion,
} = RouteManagerApi;
const { confirm } = Modal;
const apiDebounceRegion = (search: string) => {
  return CommonApi.getSearchRegion({ searchText: search }).then(
    (res: any) => res.data || [],
  );
};
const apiDebounceRouter = (search: string, version: string) => {
  return getSearchRouterBaseVersion({
    searchText: search,
    missingFixedRouteSalary: true,
    version: version,
  }).then(
    (res: any) =>
      res.data?.map((ite: any) => ({ label: ite.code, value: ite._id })) || [],
  );
};

const RouteManager = () => {
  //Define constant
  const [loading, setLoading] = useState(false);
  const [increLoading, setIncreLoading] = useState(0);
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Thông tin chung",
      disabled: !checkPermissions("ROUTE_BASE", "view", features),
    },
    {
      key: "2",
      label: "Chi tiết",
      disabled: !checkPermissions("FIXED_ROUTE_SALARY", "view", features),
    },
  ];
  const [messageApi, contextHolder] = message.useMessage();
  const { isLocked, runLocked } = useRequestLock();
  const [editIndex, setEditIndex] = useState<any>([]);
  const [editIndexVersion, setEditIndexVersion] = useState<any>([]);

  const [dataRouterSalaryVersion, setDataRouterSalaryVersion] = useState<any>(
    [],
  );

  const [detailFormInstance] = FormAntd.useForm();
  const routeDetailRequestKey = `route-detail:${detailFormInstance.getFieldValue("_id")}`;
  const routeDetailLocked = isLocked(routeDetailRequestKey);
  const [importFormInstance] = FormAntd.useForm();
  const importSelectedName = FormAntd.useWatch("name", importFormInstance);
  const [detail, setDetail] = useState(false);
  const [activeTabs, setActiveTabs] = useState(
    items.filter((item) => !item.disabled)[0]?.key,
  );
  const activeRouteFeature =
    activeTabs === "1" ? "ROUTE_BASE" : "FIXED_ROUTE_SALARY";
  const routeDetailReadOnly = !checkPermissions(
    "ROUTE_BASE",
    "edit",
    features,
  );
  const canImportRouteSalary = checkPermissions(
    "FIXED_ROUTE_SALARY",
    "import",
    features,
  );

  const [onModalPostion, setOnModalPosition] = useState(false);
  const [openModalImportSalary, setOpenModalImportSalary] = useState(false);

  const [regionAndDirectionSelectOptions, setRegionAndDirectionSelectOptions] =
    useState<any>({ directions: [], regions: [] });
  const [provines, setProvines] = useState([]);

  const [activeRowKey, setActiveRowKey] = useState<string | null>(null);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const typeDelivery = [
    { label: "BẮC - NAM", value: "ROAD" },
    { label: "CẢNG", value: "EXIM" },
    { label: "BIÊN", value: "BORDER" },
    { label: "ĐƯỜNG THUỶ", value: "WATERWAY" },
    { label: "CHUYỂN KHO", value: "TRANSFER" },
  ];

  const REQUIRED_FIELDS = [
    "code",
    "receipt",
    "delivery",
    "roadType",
    "direction",
    // "description",
    "haveGoodsDistance",
    "noGoodsDistance",
    "region",
  ];
  const REQUIRED_FIELDS_VERSION = ["name", "note", "validFrom"];

  const [filters, setFilters] = useState<any>({});
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const handleRouteFiltersChange = (nextFilters: any) => {
    setPagination((prev) => resetPaginationToFirstPage(prev));
    setFilters((prev: any) =>
      typeof nextFilters === "function" ? nextFilters(prev) : nextFilters,
    );
  };
  const routeVersionActionDisabledState = getRouteVersionActionDisabledState(
    checkPermissions,
    features,
  );
  const newObj = {
    _id: null,
    code: null,
    receipt: null,
    delivery: null,
    region: null,
    roadType: null,
    haveGoodsDistance: null,
    noGoodsDistance: null,
    cont20: null,
    cont40: null,
    cont20_kethop: null,
    cont40_kethop: null,
  };

  const colsDetail = [
    {
      title: "Cont20",
      dataIndex: "cont20",
      importTitle: "Cont20 (ĐƠN)",
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "",
      //   },
      // },
    },
    {
      title: "Cont20 (KH1)",
      dataIndex: "cont20Combined1",
      importTitle: "Cont20 (KẾT HỢP 1)",
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "",
      //   },
      // },
    },
    {
      title: "Cont20 (KH2)",
      dataIndex: "cont20Combined2",
      importTitle: "Cont20 (KẾT HỢP 2)",
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "",
      //   },
      // },
    },
    {
      title: "Cont40",
      dataIndex: "cont40",
      importTitle: "Cont40 (ĐƠN)",
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "",
      //   },
      // },
    },
    {
      title: "Cont40 (KH1)",
      dataIndex: "cont40Combined1",
      importTitle: "Cont40 (KẾT HỢP 1)",
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "",
      //   },
      // },
    },
    {
      title: "Cont40 (KH2)",
      dataIndex: "cont40Combined2",
      importTitle: "Cont40 (KẾT HỢP 2)",
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "",
      //   },
      // },
    },
  ];
  const colsRouter: any = [
    {
      title: "#",
      dataIndex: "_id",
      width: 50,
      fixed: "left",
      hidden: false,
      render: (row: any, record: any, index: number) =>
        record.__sttExcel ?? index + 1,
    },
    {
      title: "Mã tuyến",
      dataIndex: "code",
      filterDataIndex: "searchText",
      fixed: false,
      hidden: false,
      editType: activeTabs === "2" ? "DebounceSelect" : "Input",
      width: 150,
      editProps: (row: any, record: any, editIndex: any) => {
        const editRecord =
          editIndex?.length > 0 &&
          editIndex.find((ite: any) => record._id === ite.index);
        const valDisabled =
          editRecord && editRecord.record.status === "new"
            ? false
            : activeTabs === "2";
        return {
          disabled: valDisabled,
          fetchOptions: (search: string) => {
            return apiDebounceRouter(search, activeRowKey ?? "");
          },
          showSearch: true,
          onChange: (val: any, dataSource: any) => {
            if (!valDisabled && activeTabs === "2") {
              handleOnChangeRouterSalary(
                val,
                record._id,
                editIndex,
                dataSource,
              );
            }
          },
        };
      },
      filterConfig: {
        type: "string",
        filterProps: {
          placeholder: "Nhập mã tuyến",
        },
      },
    },
    {
      title: "Khu vực",
      dataIndex: "region",
      importTitle: "Khu vực",
      fixed: false,
      hidden: false,
      editType: "SelectOption",
      filterConfig: {
        type: "select",
        filterProps: {
          options: regionAndDirectionSelectOptions.regions,
          showSearch: true,
          optionFilterProp: "label",
          placeholder: "Nhập khu vực",
        },
      },
      editProps: {
        value: (row: any) => row?._id,
        options: regionAndDirectionSelectOptions.regions,
        disabled: activeTabs === "2",
      },
      colReturn: (row: any) =>
        row?.name ??
        (regionAndDirectionSelectOptions.regions.find(
          (r: any) => r.value === row,
        )?.label ||
          ""),
      render: (row: any) =>
        row?.name ??
        (regionAndDirectionSelectOptions.regions.find(
          (r: any) => r.value === row,
        )?.label ||
          ""),
    },
    {
      title: "Chiều hàng",
      dataIndex: "direction",
      importTitle: "Chiều hàng",
      fixed: false,
      hidden: false,
      editType: "SelectOption",
      filterConfig: {
        type: "select",
        filterProps: {
          options: regionAndDirectionSelectOptions.directions,
          showSearch: true,
          optionFilterProp: "label",
          placeholder: "Nhập chiều hàng",
        },
      },
      editProps: {
        value: (row: any) => row?._id,
        options: regionAndDirectionSelectOptions.directions,
        disabled: activeTabs === "2",
      },
      colReturn: (row: any) =>
        row?.name ??
        (regionAndDirectionSelectOptions.directions.find(
          (r: any) => r.value === row,
        )?.label ||
          ""),
      render: (row: any) =>
        row?.name ??
        (regionAndDirectionSelectOptions.directions.find(
          (r: any) => r.value === row,
        )?.label ||
          ""),
      // editProps: {
      //   value: (row: any) => row?._id,
      //   options: regionSelectOptions,
      //   disabled: activeTabs === "2",
      // },
      // colReturn: (row: any) =>
      //   row?.name ??
      //   (regionSelectOptions.find((r: any) => r.value === row)?.label || ""),
      // render: (row: any) =>
      //   row?.name ??
      //   (regionSelectOptions.find((r: any) => r.value === row)?.label || ""),
    },
    {
      title: "Hình thức VC",
      dataIndex: "roadType",
      importTitle: "Hình thức vận chuyển",
      fixed: false,
      hidden: false,
      editType: "SelectOption",
      filterConfig: {
        type: "select",
        filterProps: {
          options: typeDelivery,
          placeholder: "Nhập hình thức vận chuyển",
        },
      },
      editProps: {
        value: (row: any) => normalizeRouteRoadType(row),
        disabled: activeTabs === "2",
        options: typeDelivery,
      },
      colReturn: (row: any) =>
        typeDelivery.find(
          (ite) => ite.value === normalizeRouteRoadType(row),
        )?.label,
    },
    {
      title: "Điểm nhận",
      dataIndex: "receipt",
      // filterDataIndex: "pReceipt",
      importTitle: (row: any, record: any) => {
        return `${record["Xã/Phường (đóng hàng)"]} - ${record["Tỉnh/thành phố (đóng hàng)"]}`;
      },

      fixed: false,
      hidden: false,
      editType: "DebounceSelect",
      filterConfig: {
        type: "string",
        // filterProps: {
        //   options: provines,
        //   showSearch: true,
        //   optionFilterProp: "label",
        //   placeholder: "Nhập điểm nhận",
        // },
      },
      editProps: {
        value: (row: any) => (row?.address ? row.address : row?.label),
        fetchOptions: apiDebounceRegion,
        showSearch: true,
        disabled: activeTabs === "2",
      },
      colReturn: (row: any) => (row?.address ? row.address : row?.label),
      render: (row: any) => (row?.address ? row.address : row?.label),
    },
    {
      title: "Điểm trả",
      dataIndex: "delivery",
      // filterDataIndex: "pDelivery",
      importTitle: (row: any, record: any) =>
        `${record["Xã/Phường (trả hàng)"]} - ${record["Tỉnh/thành phố (trả hàng)"]}`,
      fixed: false,
      hidden: false,
      editType: "DebounceSelect",
      filterConfig: {
        type: "string",
        // filterProps: {
        //   options: provines,
        //   showSearch: true,
        //   optionFilterProp: "label",
        //   placeholder: "Nhập điểm trả",
        // },
      },
      editProps: {
        value: (row: any) => (row?.address ? row.address : row?.label),
        fetchOptions: apiDebounceRegion,
        showSearch: true,
        disabled: activeTabs === "2",
      },
      colReturn: (row: any) => (row?.address ? row.address : row?.label),
      render: (row: any) => (row?.address ? row.address : row?.label),
    },
    {
      title: "Km có hàng",
      dataIndex: "haveGoodsDistance",
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        // formatter: (value: number) =>
        //   `${value} km`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
        disabled: activeTabs === "2",
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " km",
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "Nhập số km",
      //   },
      // },
    },
    {
      title: "Km không hàng",
      dataIndex: "noGoodsDistance",
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        // formatter: (value: number) =>
        //   `${value} km`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
        disabled: activeTabs === "2",
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " km",
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "Nhập số km",
      //   },
      // },
    },
    activeTabs === "1" && {
      title: "Mô tả",
      dataIndex: "description",
      fixed: false,
      hidden: false,
      editType: "Input",
      editProps: {},
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "Nhập mô tả",
      //   },
      // },
    },
  ];
  const [columns, setColumns] = useState<any>(colsRouter);

  const columnsRender = buildColumnsWithHeaderFilters(
    [
      ...decorateEditableColumns(columns, {
        editIndex,
        getDataSource: () => dataSource,
        onUpdate: (dataIndex, value, rowId) =>
          handleUpdateRow(dataIndex, value, rowId),
      }),
      {
        title: "",
        key: "action",
        width: 60,
        fixed: "right",
        render: (_: any, record: any, index: number) => {
          const requiredAction =
            record.status === "new" ? "add" : "edit";
          const canSave = checkPermissions(
            activeRouteFeature,
            requiredAction,
            features,
          );

          return editIndex.find((ind: any) => ind.index === _._id) ? (
            <div>
              <Button
                loading={isLocked(`route-row:${_._id}`)}
                disabled={isLocked(`route-row:${_._id}`) || !canSave}
                onClick={() => {
                  handleActionSave(_._id);
                }}
              >
                Lưu
              </Button>{" "}
              <Button
                disabled={isLocked(`route-row:${_._id}`)}
                onClick={() => {
                  handleActionCancel(_._id);
                }}
              >
                Hủy
              </Button>
            </div>
          ) : (
            <TableActionButtons
              items={[
                {
                  key: "detail",
                  label: "Chi tiết",
                  icon: <EyeOutlined />,
                  tone: "info",
                  onClick: () => handleActionTable("detail", record, _._id),
                },
                {
                  key: "edit",
                  label: "Chỉnh sửa",
                  icon: <EditFilled />,
                  tone: "edit",
                  disabled:
                    activeTabs === "1"
                      ? !checkPermissions("ROUTE_BASE", "edit", features)
                      : activeTabs === "2" &&
                        !checkPermissions(
                          "FIXED_ROUTE_SALARY",
                          "edit",
                          features,
                        ),
                  onClick: () => handleActionTable("edit", record, _._id),
                },
                {
                  key: "delete",
                  label: "Xoá",
                  icon: <DeleteOutlined />,
                  tone: "delete",
                  danger: true,
                  disabled:
                    !canDeleteRouteRow(activeTabs) ||
                    (activeTabs === "1"
                      ? !checkPermissions("ROUTE_BASE", "delete", features)
                      : activeTabs === "2" &&
                        !checkPermissions(
                          "FIXED_ROUTE_SALARY",
                          "delete",
                          features,
                        )),
                  onClick: () => handleActionTable("delete", record, _._id),
                },
              ]}
            />
          );
        },
      },
    ],
    filters,
    handleRouteFiltersChange,
  );
  const columnsVersion: any = [
    {
      title: "#",
      dataIndex: "_id",
      key: "_id",
      width: 50,
      render: (row: any, record: any, index: number) => index + 1,
    },
    {
      title: "Mã phiên bản",
      dataIndex: "name",
      editType: "Input",
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      editType: "Input",
      editProps: {},
    },
    {
      title: "Ngày hiệu lực",
      dataIndex: "validFrom",
      editType: "DatePicker",
      colReturn: (row: any) => dayjs(row).format("DD/MM/YYYY"),
    },
    // {
    //   title: "Ngày hết hạn",
    //   dataIndex: "expiredDate",
    //   editType: "DatePicker",
    //   colReturn: (row: any) => dayjs(row).format("DD/MM/YYYY"),
    // },
    // {
    //   title: "Trạng thái",
    //   dataIndex: "state",
    //   render: (row: any, record: any) => (
    //     <div
    //       style={{
    //         color: record.state === "VALID" ? "#05ff00" : "#F63535",
    //         fontWeight: "bold",
    //       }}
    //     >
    //       {record.state === "VALID" ? "Đang hoạt động" : "Hết hạn"}
    //     </div>
    //   ),
    // },
  ];
  const columnsRenderVersion: any = [
    ...decorateEditableColumns(columnsVersion, {
      editIndex: editIndexVersion,
      getDataSource: () => dataRouterSalaryVersion,
      onUpdate: (dataIndex, value, rowId) =>
        handleUpdateRowVersion(dataIndex, value, rowId),
    }),
    {
      title: "",
      key: "action",
      fixed: true,
      width: 90,
      render: (_: any, record: any, index: number) =>
        editIndexVersion.find((ind: any) => ind.index === _._id) ? (
          <div>
            <Button
              loading={isLocked(`route-version:${_._id}`)}
              disabled={
                isLocked(`route-version:${_._id}`) ||
                !checkPermissions(
                  "FIXED_ROUTE_SALARY",
                  "edit",
                  features,
                )
              }
              onClick={() => {
                handleActionSaveVersion(_._id, index);
              }}
            >
              Lưu
            </Button>{" "}
            <Button
              disabled={isLocked(`route-version:${_._id}`)}
              onClick={() => {
                handleActionCancelVersion(_._id);
              }}
            >
              Hủy
            </Button>
          </div>
        ) : (
          <TableActionButtons
            items={[
              {
                key: "edit",
                label: "Chỉnh sửa",
                icon: <EditFilled />,
                tone: "edit",
                disabled: routeVersionActionDisabledState.edit,
                onClick: () => handleActionTableVersion("edit", record, _._id),
              },
              {
                key: "download",
                label: "Tải xuống",
                icon: <DownloadOutlined />,
                tone: "download",
                disabled: routeVersionActionDisabledState.download,
                onClick: () =>
                  handleActionTableVersion("download", record, _._id),
              },
            ]}
          />
        ),
      // render: (_: any, record: any, index: number) => (
      //   <Row justify="space-between">
      //     <Button
      //       icon={<ArrowDownCircle />}
      //       onClick={() => {
      //         ;
      //       }}
      //       disabled={
      //         !checkPermissions("FIXED_ROUTE_SALARY", "export", features)
      //       }
      //     />
      //     <Button
      //       icon={<PencilDash />}
      //       onClick={() => {
      //         getExportVersion(record._id, record.name);
      //       }}
      //       disabled={!checkPermissions("FIXED_ROUTE_SALARY", "edit", features)}
      //     />
      //   </Row>
      // ),
    },
  ];

  const configInput: any = {
    dataSource: {
      table: `posts`,
      update: {
        isBackendData: false,
      },
    },
    fields: [
      {
        displayType: "Group",
        dataIndex: "_id",
        col: { span: 24 },
        divider: true,
        className: [styles.FormItem].join(" "),
        fields: [
          {
            label: "Mã tuyến", // show label
            dataIndex: "code", // key
            displayType: "Input", // type input
            col: { span: 8 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              disabled: routeDetailReadOnly,
            },
          },
          {
            label: "Khu vực", // show label
            dataIndex: "region", // key
            displayType: "Select", // type input
            col: { span: 8 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              disabled: routeDetailReadOnly,
              options: regionAndDirectionSelectOptions.regions,
            },
          },
          {
            label: "Chiều hàng", // show label
            dataIndex: "direction", // key
            displayType: "Select", // type input
            col: { span: 8 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              disabled: routeDetailReadOnly,
              options: regionAndDirectionSelectOptions.directions,
            },
          },
          {
            label: "Hình thức VC", // show label
            dataIndex: "roadType", // key
            displayType: "Select", // type input
            col: { span: 8 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              disabled: routeDetailReadOnly,
              options: typeDelivery,
            },
          },
          {
            label: "Điểm nhận", // show label
            dataIndex: "receipt", // key
            displayType: "SelectOption", // type input
            col: { span: 8 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              disabled: routeDetailReadOnly,
              fetchOptions: apiDebounceRegion,
              showSearch: true,
            },
          },
          {
            label: "Điểm trả", // show label
            dataIndex: "delivery", // key
            displayType: "SelectOption", // type input
            col: { span: 8 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              disabled: routeDetailReadOnly,
              fetchOptions: apiDebounceRegion,
              showSearch: true,
            },
          },
          {
            label: "Km có hàng", // show label
            dataIndex: "haveGoodsDistance", // key
            displayType: "InputNumber", // type input
            col: { span: 12 },
            rules: [],
            input: {
              disabled: routeDetailReadOnly,
              control: false,
            },
          },
          {
            label: "Km không hàng", // show label
            dataIndex: "noGoodsDistance", // key
            displayType: "InputNumber", // type input
            col: { span: 12 },
            rules: [],
            input: {
              disabled: routeDetailReadOnly,
              control: false,
            },
          },
          {
            label: "Mô tả", // show label
            dataIndex: "description", // key
            displayType: "TextArea", // type input
            col: { span: 24 },
            rules: [],
            input: {
              disabled: routeDetailReadOnly,
              control: false,
            },
          },
        ],
      },
    ],
  };
  const configInputImportForm: any = {
    dataSource: {
      table: `posts`,
      update: {
        isBackendData: false,
      },
    },
    fields: [
      {
        displayType: "Group",
        dataIndex: "_id",
        col: { span: 24 },
        divider: true,
        className: [styles.FormItem].join(" "),
        fields: [
          {
            label: "Phiên bản", // show label
            dataIndex: "name", // key
            displayType: "Select", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              onChange: (name: any) => {
                importFormInstance.setFieldsValue({
                  validFrom: getRouteImportValidFrom(
                    name,
                    dataRouterSalaryVersion,
                  ),
                });
              },
              options: [
                {
                  label: "Phiên bản mới",
                  value: "new",
                },
                ...(dataRouterSalaryVersion?.length > 0
                  ? dataRouterSalaryVersion.map((item: any) => ({
                      label: item.name,
                      value: item._id,
                    }))
                  : []),
              ],
            },
          },
          {
            label: "Ngày hiệu lực", // show label
            dataIndex: "validFrom", // key
            displayType: "DatePicker", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              disabled: importSelectedName !== "new",
              style: { width: "100%" },
            },
          },
        ],
      },
    ],
  };
  // Function to create
  const getPermissionRegionAndDirection = async () => {
    try {
      const resDirection = await getPermissionDirections({});
      const resRegion = await getPermissionRegions({});
      setRegionAndDirectionSelectOptions({
        directions:
          resDirection?.map((direction: any) => ({
            label: direction.name,
            value: direction.code,
          })) || [],
        regions:
          resRegion?.map((region: any) => ({
            label: region.name,
            value: region._id,
          })) || [],
      });
    } catch (error: any) {
      messageApi.error(
        error?.message ||
          "Không thể tải danh sách khu vực và chiều hàng, vui lòng thử lại",
      );
    }
  };

  //Function to handle action
  const handleOnChangeRouterSalary = async (
    router: any,
    id: string,
    editIndex: any,
    dataSource: any,
  ) => {
    try {
      const detailRouter = await getOneRouter(router.value);
      const detail = detailRouter.data;
      const { nextEditRows, nextRows } = applyRouteDetailToSalaryRow({
        editRows: editIndex,
        rows: dataSource,
        targetId: id,
        detail,
      });

      setDataSource(nextRows);
      setEditIndex(nextEditRows);
    } catch (error: any) {
      messageApi.error(
        error?.message || "Không thể tải thông tin mã tuyến, vui lòng thử lại",
      );
    }
  };
  const handleOnShortDeleted = () => {
    confirm({
      title: "Xác nhận xoá",
      content:
        "Bạn có chắc chắn muốn xoá " +
        selectedRowKeys.length +
        " bản ghi đã chọn không?",
      okText: "Xoá",
      cancelText: "Huỷ",
      okType: "danger",
      onOk() {
        shortDeleteRouterBase({ ids: selectedRowKeys as string[] })
          .then(() => {
            setDataSource((prev: any) => {
              const deleteResult = applyRouteDeleteResult({
                rows: prev,
                deletedIds: selectedRowKeys as string[],
                total: pagination.total,
              });

              setPagination((paginationPrev) =>
                getRoutePaginationAfterDelete({
                  total: paginationPrev.total,
                  current: paginationPrev.current,
                  pageSize: paginationPrev.pageSize,
                  deletedCount: (selectedRowKeys as string[]).length,
                }),
              );

              return deleteResult.nextRows;
            });
            setSelectedRowKeys([]);
          })
          .catch((error) => {
            messageApi.error(
              error?.message || "Xoá bản ghi thất bại, vui lòng thử lại",
            );
          });
      },
      onCancel() {
        setSelectedRowKeys([]);
      },
    });
  };
  const handleActionTable = (action: string, record: any, index: string) => {
    switch (action) {
      case "detail":
        setDetail(true);
        detailFormInstance.setFieldsValue(
          toRouteDetailFormValues(resolveRouteDetailRecord(record, activeTabs)),
        );
        break;
      case "edit":
        setEditIndex([...editIndex, { index: index, record: { ...record } }]);
        break;
      case "delete":
        if (!canDeleteRouteRow(activeTabs)) {
          messageApi.warning(
            "Bản ghi chi tiết chưa hỗ trợ xóa trực tiếp tại màn này",
          );
          return;
        }
        confirm({
          title: "Xác nhận xoá",
          content: "Bạn có chắc chắn muốn xoá bản ghi này không?",
          okText: "Xoá",
          cancelText: "Huỷ",
          okType: "danger",
          onOk() {
            shortDeleteRouterBase({ ids: [index] as string[] })
              .then(() => {
                setDataSource((prev: any) => {
                  const deleteResult = applyRouteDeleteResult({
                    rows: prev,
                    deletedIds: [record._id],
                    total: pagination.total,
                  });

                  setPagination((paginationPrev) =>
                    getRoutePaginationAfterDelete({
                      total: paginationPrev.total,
                      current: paginationPrev.current,
                      pageSize: paginationPrev.pageSize,
                      deletedCount: 1,
                    }),
                  );

                  return deleteResult.nextRows;
                });
                // đồng thời xoá khỏi editIndex nếu đang edit
                setEditIndex((prev: any[]) =>
                  prev.filter((item) => item.index !== index),
                );
              })
              .catch((error) => {
                messageApi.error(
                  error?.message || "Xoá bản ghi thất bại, vui lòng thử lại",
                );
              });
          },
          onCancel() {},
        });
        // tìm index trong data theo id

        break;

      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  const handleActionTableVersion = (
    action: string,
    record: any,
    index: string,
  ) => {
    switch (action) {
      case "edit":
        setEditIndexVersion([
          ...editIndexVersion,
          { index: index, record: { ...record } },
        ]);
        break;
      case "download":
        getExportVersion(record._id, record.name);
        break;
      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  const handleUpdateRowVersion = (key: string, value: any, index: number) => {
    return setEditIndexVersion((prev: any[]) =>
      updateEditedRows(prev, key, value, index),
    );

    // đánh dấu touched
  };
  const handleUpdateRow = (key: string, value: any, index: number) => {
    return setEditIndex((prev: any[]) =>
      updateEditedRows(prev, key, value, index),
    );

    // đánh dấu touched
  };
  const handleActionSave = async (index: any) => {
    await runLocked(`route-row:${index}`, async () => {
      try {
        let savedRow: any = null;

        const rowEdit = editIndex.find((ind: any) => ind.index === index)?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }

        const requiredAction = rowEdit.status === "new" ? "add" : "edit";
        if (!checkPermissions(activeRouteFeature, requiredAction, features)) {
          return;
        }

        // check NULL các field req
        if (hasNullRequiredField(rowEdit, REQUIRED_FIELDS)) {
          messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
          return;
        }

        if (activeTabs === "2" && !activeRowKey) {
          messageApi.error("Vui lòng chọn phiên bản lương trước khi lưu");
          return;
        }

        const isNew = rowEdit.status === "new";

        // payload đúng shape API
        const payload = buildRouteBasePayload(rowEdit);
        const payloadSalary = buildRouteSalaryPayload(rowEdit);

        // ===== CALL API =====
        if (activeTabs === "2") {
          if (isNew) {
            if (!rowEdit.routerId) {
              messageApi.error("Vui lòng chọn mã tuyến trước khi lưu");
              return;
            }

            const res = await postCreateSalary({
              state: "VALID",
              salary: payloadSalary,
              routeBase: rowEdit.routerId,
              versionId: activeRowKey ?? "",
            });

            const saveOutcome = resolveRouteSaveOutcome({
              activeTab: activeTabs,
              isNew,
              rowEdit,
              response: res,
            });
            setEditIndex((prev: any[]) =>
              removeEditedRouteRow(prev, index),
            );

            if (saveOutcome.shouldReload) {
              setIncreLoading((prev) => prev + 1);
              return;
            }
          } else {
            await putUpdateRouterSalary(
              { state: "", salary: payloadSalary },
              index,
            );
            const saveOutcome = resolveRouteSaveOutcome({
              activeTab: activeTabs,
              isNew,
              rowEdit,
            });
            savedRow = saveOutcome.nextRow;
          }
        } else if (isNew) {
          const res = await postAddRouterBase(payload);
          const saveOutcome = resolveRouteSaveOutcome({
            activeTab: activeTabs,
            isNew,
            rowEdit,
            response: res,
          });
          savedRow = saveOutcome.nextRow;
        } else {
          await putUpdateRouterBase(payload, index);
          const saveOutcome = resolveRouteSaveOutcome({
            activeTab: activeTabs,
            isNew,
            rowEdit,
          });
          savedRow = saveOutcome.nextRow;
        }

        // ===== CHỈ KHI API OK =====
        setDataSource((prev: any[]) =>
          replaceRouteRowAfterSave(prev, index, savedRow),
        );
        setEditIndex((prev: any[]) => removeEditedRouteRow(prev, index));
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleActionSaveVersion = async (index: any, key: number) => {
    if (
      !checkPermissions(
        "FIXED_ROUTE_SALARY",
        "edit",
        features,
      )
    ) {
      return;
    }

    await runLocked(`route-version:${index}`, async () => {
      try {
        const newData = [...dataRouterSalaryVersion];

        const rowEdit = editIndexVersion.find(
          (ind: any) => ind.index === index,
        )?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }

        // check NULL các field req
        if (hasNullRequiredField(rowEdit, REQUIRED_FIELDS_VERSION)) {
          messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
          return;
        }

        // payload đúng shape API
        const payload = buildRouteVersionPayload(rowEdit);

        await putUpdateRouterBaseVersion(payload, index);

        // ===== CHỈ KHI API OK =====
        newData[key] = rowEdit;
        setDataRouterSalaryVersion(newData);

        setEditIndexVersion((prev: any[]) =>
          prev.filter((ind: any) => ind.index !== index),
        );
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };

  const handleActionCancel = (index: number) => {
    const editItem = editIndex.find((ind: any) => ind.index === index);

    if (editItem?.record?.status) {
      setDataSource((prev: any) => prev.filter((_: any) => _._id !== index));
    }

    const newEdit = editIndex.filter((ind: any) => ind.index !== index);
    setEditIndex(newEdit);
  };
  const handleActionCancelVersion = (index: number) => {
    const editItem = editIndexVersion.find((ind: any) => ind.index === index);

    if (editItem?.record?.status) {
      setDataRouterSalaryVersion((prev: any) =>
        prev.filter((_: any) => _._id !== index),
      );
    }

    const newEdit = editIndexVersion.filter((ind: any) => ind.index !== index);
    setEditIndexVersion(newEdit);
  };

  const handleAddRow = () => {
    if (!checkPermissions(activeRouteFeature, "add", features)) {
      return;
    }

    if (!canCreateRouteRow(activeTabs, activeRowKey)) {
      messageApi.warning("Vui lòng chọn phiên bản lương trước khi thêm mới");
      return;
    }

    const newObjCreate = {
      ...newObj,
      status: "new",
      _id: `create-${Date.now()}`,
    };
    setDataSource([newObjCreate, ...dataSource]);
    setEditIndex([
      ...editIndex,
      { index: newObjCreate._id, record: newObjCreate },
    ]);
  };

  const handleOnUpdateModalDetail = async () => {
    if (!checkPermissions("ROUTE_BASE", "edit", features)) {
      return;
    }

    await runLocked(routeDetailRequestKey, async () => {
      try {
        await detailFormInstance.validateFields();
        const rowEdit = detailFormInstance.getFieldsValue();
        const payload = buildRouteBasePayload({
          ...rowEdit,
          receipt: { value: rowEdit.receipt?.value ?? rowEdit.receipt },
          delivery: { value: rowEdit.delivery?.value ?? rowEdit.delivery },
        });

        await putUpdateRouterBase(payload, rowEdit._id);
        setDataSource((prev) =>
          applyRouteDetailUpdateToRows({
            rows: prev,
            routeId: rowEdit._id,
            values: rowEdit,
          }),
        );
        setDetail(false);
      } catch (error: any) {
        if (error?.errorFields) {
          return;
        }

        messageApi.error(
          error?.message || "Cập nhật chi tiết thất bại, vui lòng thử lại",
        );
      }
    });
  };
  //Function to render
  const renderModalDetail = () => {
    return (
      <Modal
        open={detail}
        className={styles.Modal}
        width={"70%"}
        onCancel={() => {
          if (routeDetailLocked) return;
          setDetail(false);
          detailFormInstance.resetFields();
        }}
        onOk={handleOnUpdateModalDetail}
        confirmLoading={routeDetailLocked}
        okButtonProps={{ disabled: routeDetailLocked || routeDetailReadOnly }}
        cancelButtonProps={{ disabled: routeDetailLocked }}
        closable={!routeDetailLocked}
        maskClosable={!routeDetailLocked}
        keyboard={!routeDetailLocked}
        title="Chi tiết"
        height={"70vh"}
      >
        <Form form={detailFormInstance} {...configInput} />
      </Modal>
    );
  };

  const handleOnChangePosition = (
    dataIndex: string,
    value: boolean | "left" | "right",
    type: "hidden" | "fixed",
  ) => {
    setColumns(updateColumnDisplayState(columns, dataIndex, value, type));
  };

  const renderModalPosition = () => {
    return (
      <Modal
        open={onModalPostion}
        className={styles.Modal}
        width={"70%"}
        onCancel={() => {
          setOnModalPosition(false);
        }}
        title="Hiển thị cột"
        bodyProps={{
          style: {
            maxHeight: "70vh", // giới hạn theo chiều cao màn hình
            overflowY: "auto", // nội dung dài thì auto scroll
          },
        }}
        footer={false}
      >
        <Row>
          <Col span={16}>Tên cột</Col>
          <Col span={4}>Hiển thị</Col>
          <Col span={4}>Cố định (trái, phải)</Col>
        </Row>
        <Divider />
        {columns?.map((col: any, key: number) => (
          <div key={key}>
            <Row>
              <Col span={16}>{col.title}</Col>
              <Col span={4}>
                <Checkbox
                  checked={!col.hidden}
                  onChange={(e) => {
                    handleOnChangePosition(
                      col.dataIndex,
                      e.target.checked,
                      "hidden",
                    );
                  }}
                />
              </Col>
              <Col span={4}>
                <Checkbox
                  checked={col.fixed === "left" ? true : false}
                  onChange={(e) => {
                    handleOnChangePosition(
                      col.dataIndex,
                      e.target.checked && "left",
                      "fixed",
                    );
                  }}
                  style={{ marginRight: "20px" }}
                />
                <Checkbox
                  checked={col.fixed === "right" ? true : false}
                  onChange={(e) => {
                    handleOnChangePosition(
                      col.dataIndex,
                      e.target.checked && "right",
                      "fixed",
                    );
                  }}
                />
              </Col>
            </Row>
            <Divider />
          </div>
        ))}
      </Modal>
    );
  };

  //Function to effect
  useEffect(() => {
    if (canImportRouteSalary) return;
    if (!openModalImportSalary) return;

    setOpenModalImportSalary(false);
    importFormInstance.resetFields();
  }, [
    canImportRouteSalary,
    importFormInstance,
    openModalImportSalary,
  ]);
  useEffect(() => {
    setActiveTabs(items.filter((item) => !item.disabled)[0]?.key);
  }, [features]);
  useEffect(() => {
    let mounted = true;
    getPermissionRegionAndDirection();
    // getPermissionDirections({})
    // getPermissionRegions({})
    //   .then((res) => {
    //     if (!mounted) {
    //       return;
    //     }

    //     setRegionSelectOptions(
    //       res?.map((region: any) => ({
    //         label: region.name,
    //         value: region._id,
    //       })) || [],
    //     );
    //   })

    CommonApi.getSearchProvine({})
      .then((res: any) => {
        if (!mounted) {
          return;
        }

        setProvines(
          res.data?.map((ite: any) => ({ label: ite.name, value: ite._id })),
        );
      })
      .catch((error: any) => {
        if (!mounted) {
          return;
        }

        messageApi.error(
          error?.message ||
            "Không thể tải danh sách tỉnh/thành phố, vui lòng thử lại",
        );
      });

    return () => {
      mounted = false;
    };
  }, [messageApi]);

  // useEffect(() => {
  //   setColumns(colsRouter);
  // }, []);

  useEffect(() => {
    let mounted = true;

    getAllRouterSalaryVersion({})
      .then((res) => {
        if (!mounted) {
          return;
        }

        const nextRows = res?.data || [];
        setDataRouterSalaryVersion(nextRows);
        setActiveRowKey((prev) => resolveRouteVersionRowKey(nextRows, prev));
      })
      .catch((error: any) => {
        if (!mounted) {
          return;
        }

        messageApi.error(
          error?.message ||
            "Không thể tải danh sách phiên bản lương, vui lòng thử lại",
        );
      });

    return () => {
      mounted = false;
    };
  }, [increLoading, messageApi]);

  useEffect(() => {
    const nextColumns =
      activeTabs === "2" ? [...colsRouter, ...colsDetail] : [...colsRouter];

    setColumns((prev: any[]) =>
      mergeRouteColumnsWithCurrentState(prev, nextColumns),
    );
  }, [activeTabs, regionAndDirectionSelectOptions]);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      setLoading(true);

      try {
        if (
          activeTabs === "2" &&
          !shouldLoadRouteSalaryRows(activeTabs, activeRowKey)
        ) {
          if (mounted) {
            setDataSource([]);
            setPagination((prev) => ({
              ...prev,
              total: 0,
            }));
          }
          return;
        }

        const res = shouldLoadRouteSalaryRows(activeTabs, activeRowKey)
          ? await getAllRouterSalary(
              {
                current: pagination.current,
                pageSize: pagination.pageSize,
                ...filters,
              },
              activeRowKey,
            )
          : await getAllRouterBase({
              current: pagination.current,
              pageSize: pagination.pageSize,
              ...filters,
            });

        if (mounted && features) {
          setDataSource(res?.data ?? []);
          setPagination((prev) => ({
            ...prev,
            total: res?.totalItem || 0,
          }));
        }
      } catch (error: any) {
        if (mounted) {
          messageApi.error(
            error?.message ||
              "Không thể tải dữ liệu mã tuyến, vui lòng thử lại",
          );
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [
    increLoading,
    pagination.current,
    pagination.pageSize,
    filters,
    activeRowKey,
    features,
    activeTabs,
    messageApi,
  ]);
  //Main render
  return (
    <PermissionDirect screen={["ROUTE_BASE", "FIXED_ROUTE_SALARY"]}>
      <div className={styles.RouterManager}>
        {contextHolder}
        <div className="container">
          <HeaderTable
            title="Mã tuyến"
            buttons={[
              {
                children: "Mẫu import",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  if (!checkPermissions("ROUTE_BASE", "export", features)) {
                    return;
                  }
                  CommonApi.getDownloadTemplate("routeBase", "Mã tuyến.xlsx");
                },
                type: "primary",
                disabled: !checkPermissions("ROUTE_BASE", "export", features),
              },
              {
                children: "Cài đặt hiển thị",
                icon: <Setting />,
                onClick: () => {
                  setOnModalPosition(true);
                },
                type: "primary",
              },
              {
                children: "Import",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  if (!canImportRouteSalary) return;
                  // setIncreLoading(increLoading + 1);
                  setOpenModalImportSalary(true);
                },
                style: {
                  backgroundColor: checkPermissions(
                    "FIXED_ROUTE_SALARY",
                    "import",
                    features,
                  )
                    ? "#00529F"
                    : "#C0C0C0",
                },
                disabled: !checkPermissions(
                  "FIXED_ROUTE_SALARY",
                  "import",
                  features,
                ),
              },
              {
                children: "Thêm mới",
                icon: <PlusIcon />,
                onClick: handleAddRow,
                style: {
                  backgroundColor:
                    (activeTabs === "2" &&
                      canCreateRouteRow(activeTabs, activeRowKey) &&
                      checkPermissions(
                        "FIXED_ROUTE_SALARY",
                        "add",
                        features,
                      )) ||
                    (activeTabs === "1" &&
                      checkPermissions("ROUTE_BASE", "add", features))
                      ? "#0076E3"
                      : "#C0C0C0",
                },
                disabled:
                  activeTabs === "1"
                    ? !checkPermissions("ROUTE_BASE", "add", features)
                    : activeTabs === "2" &&
                      (!checkPermissions(
                        "FIXED_ROUTE_SALARY",
                        "add",
                        features,
                      ) ||
                        !canCreateRouteRow(activeTabs, activeRowKey)),
              },
            ]}
          />
          <Row align="middle" justify="space-between">
            <Tabs
              activeKey={activeTabs}
              items={items}
              onChange={(tab) => {
                const nextState = getRouteTabChangeState(pagination.pageSize);
                setSelectedRowKeys(nextState.selectedRowKeys);
                setEditIndex(nextState.editIndex);
                setEditIndexVersion(nextState.editIndexVersion);
                setFilters(nextState.filters);
                setPagination((prev) => ({
                  ...prev,
                  ...nextState.pagination,
                }));
                setActiveTabs(tab);
              }}
            />
          </Row>
          {activeTabs === "2" && (
            <Table
              size="small"
              dataSource={dataRouterSalaryVersion}
              columns={columnsRenderVersion}
              onRow={(record) => {
                return {
                  onDoubleClick: (e) => {
                    const _id = record._id;
                    const nextState = getRouteVersionSelectionState(
                      pagination.pageSize,
                    );
                    setEditIndex(nextState.editIndex);
                    setFilters(nextState.filters);
                    setPagination((prev) => ({
                      ...prev,
                      ...nextState.pagination,
                    }));
                    setActiveRowKey(_id);
                  },
                };
              }}
              rowClassName={(record: any) =>
                record._id === activeRowKey ? styles.HightLightRow : ""
              }
              pagination={{ pageSize: 3 }}
              rowKey={(record) => String(record._id)}
            />
          )}
          <div
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            {activeTabs === "1" && selectedRowKeys.length > 0 && (
              <Button
                danger
                type="primary"
                onClick={handleOnShortDeleted}
                disabled={!checkPermissions("ROUTE_BASE", "delete", features)}
              >
                Xoá
              </Button>
            )}
            <Table
              loading={loading}
              size="small"
              dataSource={dataSource}
              columns={columnsRender}
              pagination={false}
              rowKey={(record) => String(record._id)}
              scroll={{ x: "max-content" }}
              style={{ width: "100%" }} // Full theo container
              rowSelection={
                activeTabs === "1"
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: (selectedKeys) => {
                        setSelectedRowKeys(selectedKeys);
                      },
                    }
                  : undefined
              }
            />
          </div>

          <Button
            className={styles.ButtonPlus}
            icon={<PlusIcon />}
            onClick={handleAddRow}
            disabled={
              activeTabs === "1"
                ? !checkPermissions("ROUTE_BASE", "add", features)
                : activeTabs === "2" &&
                  (!checkPermissions("FIXED_ROUTE_SALARY", "add", features) ||
                    !canCreateRouteRow(activeTabs, activeRowKey))
            }
          >
            Thêm mới
          </Button>

          <Pagination
            total={pagination.total}
            current={pagination.current}
            pageSize={pagination.pageSize}
            onChange={(page, pageSize) => {
              setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: pageSize || prev.pageSize,
              }));
            }}
            showSizeChanger
            align="end"
            className={styles.Pagination}
          />
          {renderModalDetail()}
          {renderModalPosition()}
          <ModalImport
            columns={[...colsRouter, ...colsDetail]}
            open={openModalImportSalary}
            onCancel={() => {
              setOpenModalImportSalary(false);
              importFormInstance.resetFields();
            }}
            precheckApi={async (file: Blob) => {
              if (!canImportRouteSalary) {
                throw new Error("Bạn không có quyền import tiền đi đường");
              }
              return postPreCheckImportRouterBase(file);
            }}
            confirmApi={(payload) => {
              if (!canImportRouteSalary) {
                return Promise.reject(
                  new Error("Bạn không có quyền import tiền đi đường"),
                );
              }
              return importFormInstance.validateFields().then(() => {
                const val = importFormInstance.getFieldsValue([
                  "validFrom",
                  "name",
                ]);
                return postConfirmImportRouterBase(
                  buildRouteImportConfirmPayload(
                    payload,
                    val,
                    dataRouterSalaryVersion,
                  ),
                ).then((res) => {
                  if (res.success) {
                    importFormInstance.resetFields();
                    setActiveRowKey(
                      resolveRouteImportSuccessActiveRowKey({
                        selectedVersionId: val.name,
                        createdVersionId: payload.versionId,
                      }),
                    );
                    setActiveTabs("2");
                    setIncreLoading(increLoading + 1);
                  }
                  return res;
                });
              });
            }}
          >
            <Form form={importFormInstance} {...configInputImportForm} />
          </ModalImport>
        </div>
      </div>
    </PermissionDirect>
  );
};

export { RouteManager };
